import { render, staticRenderFns } from "./ActionsCenter.vue?vue&type=template&id=4a04e95b&scoped=true"
import script from "./ActionsCenter.vue?vue&type=script&lang=ts"
export * from "./ActionsCenter.vue?vue&type=script&lang=ts"
import style0 from "./ActionsCenter.vue?vue&type=style&index=0&id=4a04e95b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04e95b",
  null
  
)

export default component.exports